import React from 'react';
import { CheckCircle, AlertCircle, Mail, X } from 'lucide-react';

const NotificationToast = ({ type, title, message, onClose, persistent = false }) => {
  const styles = {
    success: {
      bg: 'bg-green-500/10 border-green-500/20',
      icon: 'text-green-400',
      iconBg: 'bg-green-500',
      Icon: CheckCircle
    },
    error: {
      bg: 'bg-red-500/10 border-red-500/20',
      icon: 'text-red-400',
      iconBg: 'bg-red-500',
      Icon: AlertCircle
    },
    warning: {
      bg: 'bg-amber-500/10 border-amber-500/20',
      icon: 'text-amber-400',
      iconBg: 'bg-amber-500',
      Icon: AlertCircle
    },
    info: {
      bg: 'bg-blue-500/10 border-blue-500/20',
      icon: 'text-blue-400',
      iconBg: 'bg-blue-500',
      Icon: Mail
    }
  };

  const style = styles[type] || styles.info;
  const IconComponent = style.Icon;

  return (
    <div className="fixed bottom-4 right-4 z-[60]">
      <div className={`${style.bg} backdrop-blur-xl rounded-2xl p-4 border shadow-xl max-w-md`}>
        <div className="flex items-start gap-3">
          <div className={`${style.iconBg} rounded-full p-2 flex-shrink-0`}>
            <IconComponent className="w-5 h-5 text-white" />
          </div>
          <div className="flex-1">
            <div className={`text-sm font-semibold ${style.icon} mb-1`}>{title}</div>
            <div className="text-xs text-slate-300">{message}</div>
          </div>
          <button onClick={onClose} className="text-slate-400 hover:text-white transition-all">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationToast;